import axios from 'axios';

const config = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
};

const getCart = () => {
  return axios.get('/cart.js', config)
}

const updateCart = (body) => {
  return axios.post('/cart/update.js', body, config)
}

const changeCart = (body) => {
  return axios.post('/cart/change.js', body, config)
}

const addToCart = (body) => {
  return axios.post('/cart/add.js', body, config);
}

export {
  getCart,
  updateCart,
  changeCart,
  addToCart,
}
